<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">{{$route.query.page}}</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row">
        <div class="col-4">
          <txt label="Name of Child" name="child_name" v-model="model.child_name" />
        </div>
        <div class="col-4" v-if="$route.query.page == 'Children Education Allowance'">
          <txt label="Name of Institute" name="institute_name" v-model="model.institute_name" />
        </div>
        <div class="col-4" v-if="$route.query.page != 'Children Education Allowance'">
          <txt label="Name of Hostel" name="hostel_name" v-model="model.hostel_name" />
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="col-4">
          <txt label="Bill Number" name="bill_number" v-model="model.bill_number" />
        </div>
        <div class="col-4">
          <div class="label">
            <span class="input-label">Bill Date</span>
            <date-picker
              name="bill_date"
              :value="model.bill_date"
              @datevalue="(val)=> model.bill_date = val"
            />
          </div>
        </div>
        <div class="col-4">
          <txt label="Bill Amount" type="number" name="bill_amount" v-model="model.amount" />
        </div>
        <div class="col-12 margin-t-m">
          <div class="upload-heading">Upload the Fee slip</div>
          <upload @change="(val)=>docUrl=val.data.location" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Bill" type="secondary" @click="addMore()" />
        </div>
      </div>

      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="billList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_number'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_date'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'institute_name' && $route.query.page=='Children Education Allowance'"
              >{{slotprops.value.record['institute_name']}}</p>
              <p
                v-if="slotprops.value.column.key == 'hostel_name' && $route.query.page!='Children Education Allowance'"
              >{{slotprops.value.record['hostel_name']}}</p>
              <p
                v-if="slotprops.value.column.key == 'child_name'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'proofs'"
              >{{slotprops.value.record[slotprops.value.column.key]}} attacment</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      docUrl: "",
      toast: false,
      errmsg: "",
      model: {
        child_name: "",
        institute_name: "",
        hostel_name: "",
        bill_number: "",
        bill_date: "",
        amount: 0
      },
      tableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Name of Institue",
          key: "institute_name"
        },
        {
          label: "Name of Child",
          key: "child_name"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      billList: [],
      heading: "",
      labelName: ""
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      ceaData: state => state.CEA,
      hfaData: state => state.HFA
    })
  },
  activated() {
    this.showSuccessMsg = false;
    if (this.$route.query.page == "Children Education Allowance") {
      this.tableColumns[3] = {
        label: "Name of Institute",
        key: "institute_name"
      };
      this.setCEAData();
    } else {
      this.tableColumns[3] = {
        label: "Name of Hostel",
        key: "hostel_name"
      };
      this.setHFAData();
    }
  },
  methods: {
    ...mapActions({
      saveCEAData: "dashboard/organisation/utilities/itdeclarations/saveCEA",
      saveHFAData: "dashboard/organisation/utilities/itdeclarations/saveHFA"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        if (this.$route.query.page == "Children Education Allowance") {
          await this.saveCEAData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        } else {
          await this.saveHFAData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        }
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setCEAData() {
      try {
        if (this.ceaData[this.$route.query.id]) {
          this.billList = this.ceaData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setHFAData() {
      try {
        if (this.hfaData[this.$route.query.id]) {
          this.billList = this.hfaData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMore() {
      try {
        this.billList.push({
          bill_number: this.model.bill_number,
          bill_date: this.model.bill_date,
          amount: this.model.amount,
          child_name: this.model.child_name,
          hostel_name: this.model.hostel_name,
          institute_name: this.model.institute_name,
          proofs: [this.docUrl]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          child_name: "",
          institute_name: "",
          hostel_name: "",
          bill_number: "",
          bill_date: "",
          amount: 0
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.billList.findIndex(item => item.name == record.name);
        this.billList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
